/*
  Mecca Books — Collection Best Sellers rail.

  On load, fetches THIS collection's own URL with
  ?sort_by=best-selling&section_id=<real id> appended (an independent
  request — never touches the page's actual URL or the main grid's
  active sort), pulls the pre-rendered product cards out of that
  response's [data-mb-colbest-payload] block, drops them into this
  section's own [data-mb-colbest-grid], and reveals the section.
  Stays hidden if the fetch fails for any reason.
*/
(function () {
  function getFullSectionId(root) {
    var wrapper = root.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
  }

  function initRoot(root) {
    var collectionUrl = root.getAttribute('data-collection-url');
    var grid = root.querySelector('[data-mb-colbest-grid]');
    var sectionId = getFullSectionId(root);
    if (!collectionUrl || !grid || !sectionId) return;

    var joiner = collectionUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = collectionUrl + joiner + 'sort_by=best-selling&section_id=' + sectionId;

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var payload = doc.querySelector('[data-mb-colbest-payload]');
        if (!payload || !payload.innerHTML.trim()) return;

        grid.innerHTML = payload.innerHTML;
        root.hidden = false;
      })
      .catch(function () {
        // Leave the section hidden — no guessed/wrongly-sorted fallback.
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-mb-colbest-root]').forEach(initRoot);
  });
})();